import { render, staticRenderFns } from "./LmTravelStats.vue?vue&type=template&id=87e798e6"
import script from "./LmTravelStats.vue?vue&type=script&lang=js"
export * from "./LmTravelStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports